module.exports = __webpack_public_path__ + "static/media/mode-03.629e1ba1.jpg";